/**
 * GENERATED — do not edit.
 *
 * Source: @oylo/schema (effect map) + src/schemas/overlay/.
 * Regenerate with `pnpm schema:gen`. tests/schema/drift.test.js gates this file.
 */
import { deepFreeze } from '~/lib/deepFreeze'
import diffusion_schema from '~/schemas/diffusion_schema'
import motion_schema from '~/schemas/motion_schema'
import control_schema from '~/schemas/control_schema'
import ip_schema from '~/schemas/ip_schema'
import filter_schema from '~/schemas/filter_schema'
import inpaint_schema from '~/schemas/inpaint_schema'

/** Every effect and its schema. `objects` is absent: it is the scene graph, not an effect. */
export const EFFECT_SCHEMAS = deepFreeze({
	diffusion: diffusion_schema,
	motion: motion_schema,
	control: control_schema,
	ip: ip_schema,
	filter: filter_schema,
	inpaint: inpaint_schema,
})

/**
 * Every top-level key that carries state on the parameters wire — the effects above, plus `objects`.
 *
 * Read straight from the contract's `parameters`, which enumerates both — the effect map deliberately omits the scene graph, so a hand-appended literal was the alternative.
 */
export const WIRE_KEYS = new Set(['diffusion', 'motion', 'control', 'ip', 'filter', 'inpaint', 'objects'])

export default EFFECT_SCHEMAS
